import { ADD_CONTACT, REMOVE_CONTACT } from 'actions/ringCentral';

const buildContactsState = (state, payload) => {
  const contacts = state.trackedContacts.filter(
    contact =>
      contact !==
      state.trackedContacts.find(
        trackedContact =>
          trackedContact.id === payload.id &&
          trackedContact.role === payload.role &&
          trackedContact.phone === payload.phone
      )
  );

  return [...contacts, payload];
};

/**
 * @param {RingCentralState} [state]
 * @param {Action} [action]
 * @returns {RingCentralState}
 */
const domainReducer = (state = {}, action = { type: '', payload: {} }) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_CONTACT:
      return { ...state, trackedContacts: buildContactsState(state, payload) };
    case REMOVE_CONTACT:
      return { ...state, trackedContacts: state.trackedContacts.filter(item => item !== payload) };
    default:
      return state;
  }
};

/** Reducer that combines domain and app reducer */
export default domainReducer;
